import React from "react";
import { Check, X } from "lucide-react";
import { INCLUSIONS, EXCLUSIONS } from "../mock";

const Inclusions = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-orange-50 to-[#fffaf3]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <span className="text-amber-600 font-medium tracking-widest uppercase text-sm">
            Transparent Pricing
          </span>
          <h2 className="font-display text-3xl sm:text-4xl text-orange-900 mt-2">
            Package Inclusions &amp; Exclusions
          </h2>
          <div className="mx-auto mt-4 h-1 w-24 rounded-full bg-gradient-to-r from-amber-400 to-orange-600" />
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          <div className="rounded-3xl bg-white p-8 shadow-lg border border-green-100">
            <h3 className="font-display text-2xl text-green-700 mb-6 flex items-center gap-2">
              <span className="h-9 w-9 rounded-full bg-green-100 flex items-center justify-center">
                <Check className="h-5 w-5 text-green-700" />
              </span>
              Inclusions
            </h3>
            <ul className="space-y-4">
              {INCLUSIONS.map((item) => (
                <li key={item} className="flex items-start gap-3 text-stone-700">
                  <Check className="h-5 w-5 text-green-600 mt-0.5 shrink-0" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="rounded-3xl bg-white p-8 shadow-lg border border-red-100">
            <h3 className="font-display text-2xl text-red-700 mb-6 flex items-center gap-2">
              <span className="h-9 w-9 rounded-full bg-red-100 flex items-center justify-center">
                <X className="h-5 w-5 text-red-700" />
              </span>
              Exclusions
            </h3>
            <ul className="space-y-4">
              {EXCLUSIONS.map((item) => (
                <li key={item} className="flex items-start gap-3 text-stone-700">
                  <X className="h-5 w-5 text-red-500 mt-0.5 shrink-0" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Inclusions;
